import { FC, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import { RootState } from '@/redux/store';

import { useDeedPlotterContext } from '../boundaries/deedPlotter/provider';
import { useCustomizeLandContext } from '../customizeMyLand/provider';
import { useNavigationContext } from '../navigation/provider';
import {
  formatAcres,
  getAcresOfSelectionsPanelFeatures,
} from '../selectionsPanel/util/determineSelectionsPanelAcres';
import { SelectionsDropDownButton } from './selectionsDropDownButton';
import { SelectionsPanelContent } from './selectionsPanelContent';

export const OldSelectionsPanel: FC = () => {
  const [isSelectionsPanelExpanded, setIsSelectionsPanelExpanded] =
    useState(false);

  const allFeatures = useSelector(
    (state: RootState) => state.features.allFeatures
  );
  const {
    customizations: { allCustomizations },
  } = useCustomizeLandContext();

  const { aerialMapIsOpen } = useNavigationContext();
  const { validGroups } = useDeedPlotterContext();

  const totalAcres = useMemo(
    () => getAcresOfSelectionsPanelFeatures(allFeatures),
    [allFeatures]
  );

  const formattedTotalAcres = useMemo(
    () => formatAcres(totalAcres, false),
    [totalAcres]
  );

  const showSelectionsPanel = useMemo(() => {
    return (
      [...allFeatures, ...allCustomizations, ...validGroups].length > 0 &&
      !aerialMapIsOpen
    );
  }, [
    allCustomizations.length,
    allFeatures,
    validGroups,
    aerialMapIsOpen,
  ]);

  return (
    <div
      className={twMerge(
        'relative z-[200] max-h-[calc(100%-40px)] w-full transition-all duration-300 ease-in-out sm:top-0 sm:w-[264px]',
        showSelectionsPanel
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      )}
    >
      <SelectionsDropDownButton
        isOpen={isSelectionsPanelExpanded}
        onToggle={() =>
          setIsSelectionsPanelExpanded(!isSelectionsPanelExpanded)
        }
      />
      <SelectionsPanelContent
        formattedTotalAcres={formattedTotalAcres}
        isSelectionsPanelExpanded={isSelectionsPanelExpanded}
        setIsSelectionsPanelExpanded={setIsSelectionsPanelExpanded}
      />
    </div>
  );
};
